export function isValidLink(url) {
  return /(http(s?))\:\/\//gi.test(url)
}

export function isMissingLinkData(resource) {
  return (
    resource.format === 'url' && (!resource.url || !isValidLink(resource.url))
  )
}

export function isMissingFileData(resource) {
  return (
    resource.format === 'file' &&
    (isMissingCitation(resource) ||
      !resource.attributionSelection ||
      !resource.fileName)
  )
}

export function isMissingCitation(resource) {
  return resource.attributionSelection === 'outsideorg' && !resource.citation
}

export function isMissingContentWarnings(resource) {
  return (
    resource.hasContentWarnings &&
    (!resource.content_warnings ||
      Object.keys(resource.content_warnings).every(function (cw) {
        return (
          resource.content_warnings[cw] === '' ||
          !resource.content_warnings[cw] ||
          resource.content_warnings[cw].length === 0
        )
      }))
  )
}



// WEBPACK FOOTER //
// ./src/utils/activityedit.js